<template>
<HeroSectionPage page_title="Work & Education"/>
<div class="content">
  
  <WorkEducation
                            class="zero"
                            :isWork="work_education[0].icon"
                            :ins="work_education[0].ins"
                            :title="work_education[0].title"
                            :location="work_education[0].location"
                            :years="work_education[0].years"
                            :details="work_education[0].details"
                            /> 
            <WorkEducation 
                            class="one"
                            :isWork="work_education[1].icon"
                            :ins="work_education[1].ins"
                            :title="work_education[1].title"
                            :location="work_education[1].location"
                            :years="work_education[1].years"
                            :details="work_education[1].details"
                            /> 
            <WorkEducation 
                            class="two"
                            :isWork="work_education[2].icon"
                            :ins="work_education[2].ins"
                            :title="work_education[2].title"
                            :location="work_education[2].location"
                            :years="work_education[2].years"
                            :details="work_education[2].details"
                            />
            <WorkEducation 
                            class="three"
                            :isWork="work_education[3].icon"
                            :ins="work_education[3].ins"
                            :title="work_education[3].title"
                            :location="work_education[3].location"
                            :years="work_education[3].years"
                            :details="work_education[3].details"
                            />
</div>
<ContactsPage/>
</template>
<script>
import ContactsPage from '@/components/ContactsPage.vue';
import HeroSectionPage from '@/components/HeroSectionPage.vue';
import WorkEducation from '@/components/WorkEducation.vue';
export default{
  components:{
    HeroSectionPage, WorkEducation, ContactsPage
  },
  data(){
        return{
           work_education:[
             {
                icon:true,
                ins:"Software Development Project",
                title:"First Capital Bank Malawi",
                location:"Blantyre, Malawi",
                years:"Mar 2024 - Apr 2024",
                details:"Developed a stand-alone polling application for First Capital Bank Malawi that enabled them to conduct a product survey. It was a web-based solution to consolidate data into a central dataset accessed from anywhere. The application was custom designed to suit their brand outlook for public domain users and consolidated data was stored in an Excel spreadsheet."
               
            },
            {
                icon:true,
                ins:"Software Engineer (Internship)",
                title:"Sparc Systems Limited",
                location:"Blantyre, Malawi",
                years:"Jan 2023 - Feb 2024",  
                details:"Made substantial contribution in the development of key components for a mobile application project, including the client app, API, and dashboard using the .NET stack. (Project still remains out of the public domain till date)."                          
            },
           
            {
                icon:false,
                ins:"Bachelor's Degree in Information Technology",
                title:"Blantyre International University",
                location:"Blantyre, Malawi",
                years:"Jan 2015 - Sept 2021",
               
            },
            {
                icon:false,
                ins:"Malawi School Certificate of Education",
                title:"Chichiri Secondary School",
                location:"Blantyre, Malawi",
                years:"2010 - 2014",
            },

           ] 
        }
    }
}
</script>
<style scoped>
  .content{
    padding:2rem;
    display:grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap:1.5rem;
    margin-top:1.6rem;
}

.zero{
    grid-column:1/2;
}

.one{
    grid-column:2/3;
}

.two{
    grid-row:2/3;
}

.three{
    grid-column:2/3;
    grid-row:2/3;
}

@media(max-width: 768px){
    .content{
        display:flex;
        flex-direction: column;
        padding:1rem;
    }

    .zero, .one, .two, .three{
        grid-column:auto
    }
}


</style>